@file:OptIn(InternalResourceApi::class)

package manyverse.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/manyverse.shared.generated.resources/"

@delegate:ResourceContentHash(460_863_086)
internal val Res.string.combat_order_hint: StringResource by lazy {
      StringResource("string:combat_order_hint", "combat_order_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6406, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5954, 69),
      ))
    }

@delegate:ResourceContentHash(-1_541_957_478)
internal val Res.string.combat_order_section: StringResource by lazy {
      StringResource("string:combat_order_section", "combat_order_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6500, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6024, 44),
      ))
    }

@delegate:ResourceContentHash(825_922_718)
internal val Res.string.combat_players_section: StringResource by lazy {
      StringResource("string:combat_players_section", "combat_players_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6549, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6069, 54),
      ))
    }

@delegate:ResourceContentHash(1_746_399_443)
internal val Res.string.combat_prepare_title: StringResource by lazy {
      StringResource("string:combat_prepare_title", "combat_prepare_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6608, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6124, 48),
      ))
    }

@delegate:ResourceContentHash(-743_797_238)
internal val Res.string.combat_remove_participant: StringResource by lazy {
      StringResource("string:combat_remove_participant", "combat_remove_participant", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6665, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6173, 41),
      ))
    }

@delegate:ResourceContentHash(470_465_243)
internal val Res.string.combat_shuffle: StringResource by lazy {
      StringResource("string:combat_shuffle", "combat_shuffle", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6711, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6215, 30),
      ))
    }

@delegate:ResourceContentHash(-649_669_085)
internal val Res.string.combat_stop: StringResource by lazy {
      StringResource("string:combat_stop", "combat_stop", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6750, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6246, 35),
      ))
    }

@delegate:ResourceContentHash(-775_934_914)
internal val Res.string.configure_table: StringResource by lazy {
      StringResource("string:configure_table", "configure_table", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6794, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6282, 43),
      ))
    }

@delegate:ResourceContentHash(-1_164_924_713)
internal val Res.string.confirm: StringResource by lazy {
      StringResource("string:confirm", "confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6905, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6385, 27),
      ))
    }

@delegate:ResourceContentHash(1_065_025_232)
internal val Res.string.confirm_premade_choice: StringResource by lazy {
      StringResource("string:confirm_premade_choice", "confirm_premade_choice", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6846, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6326, 58),
      ))
    }

@delegate:ResourceContentHash(7_149_952)
internal val Res.string.conversations: StringResource by lazy {
      StringResource("string:conversations", "conversations", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6933, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6413, 33),
      ))
    }

@delegate:ResourceContentHash(-373_378_324)
internal val Res.string.copy_table_code: StringResource by lazy {
      StringResource("string:copy_table_code", "copy_table_code", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6967, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6447, 43),
      ))
    }

@delegate:ResourceContentHash(-1_228_488_294)
internal val Res.string.create: StringResource by lazy {
      StringResource("string:create", "create", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7169, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6625, 22),
      ))
    }

@delegate:ResourceContentHash(538_473_622)
internal val Res.string.create_character: StringResource by lazy {
      StringResource("string:create_character", "create_character", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7023, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6491, 48),
      ))
    }

@delegate:ResourceContentHash(-491_827_502)
internal val Res.string.create_table: StringResource by lazy {
      StringResource("string:create_table", "create_table", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7076, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6540, 36),
      ))
    }

@delegate:ResourceContentHash(272_611_476)
internal val Res.string.create_universe: StringResource by lazy {
      StringResource("string:create_universe", "create_universe", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7121, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6577, 47),
      ))
    }

@delegate:ResourceContentHash(1_911_399_662)
internal val Res.string.crossfading: StringResource by lazy {
      StringResource("string:crossfading", "crossfading", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7192, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6648, 39),
      ))
    }

@delegate:ResourceContentHash(-138_931_149)
internal val Res.string.custom_universe_snapshot_warning: StringResource by lazy {
      StringResource("string:custom_universe_snapshot_warning", "custom_universe_snapshot_warning", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7232, 252),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6688, 208),
      ))
    }

@delegate:ResourceContentHash(1_964_797_320)
internal val Res.string.delete: StringResource by lazy {
      StringResource("string:delete", "delete", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9172, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8444, 22),
      ))
    }

@delegate:ResourceContentHash(824_021_374)
internal val Res.string.delete_account: StringResource by lazy {
      StringResource("string:delete_account", "delete_account", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7871, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7243, 42),
      ))
    }

@delegate:ResourceContentHash(824_021_374)
internal val Res.string.delete_account_confirm: StringResource by lazy {
      StringResource("string:delete_account_confirm", "delete_account_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7485, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6897, 50),
      ))
    }

@delegate:ResourceContentHash(1_867_166_893)
internal val Res.string.delete_account_loading: StringResource by lazy {
      StringResource("string:delete_account_loading", "delete_account_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7544, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6948, 62),
      ))
    }

@delegate:ResourceContentHash(1_501_522_334)
internal val Res.string.delete_account_message: StringResource by lazy {
      StringResource("string:delete_account_message", "delete_account_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7619, 194),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7011, 182),
      ))
    }

@delegate:ResourceContentHash(824_084_352)
internal val Res.string.delete_account_title: StringResource by lazy {
      StringResource("string:delete_account_title", "delete_account_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7814, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7194, 48),
      ))
    }

@delegate:ResourceContentHash(-11_928_016)
internal val Res.string.delete_character: StringResource by lazy {
      StringResource("string:delete_character", "delete_character", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8172, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7520, 48),
      ))
    }

@delegate:ResourceContentHash(701_047_627)
internal val Res.string.delete_character_in_table_message: StringResource by lazy {
      StringResource("string:delete_character_in_table_message", "delete_character_in_table_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7922, 165),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7286, 157),
      ))
    }

@delegate:ResourceContentHash(-1_559_484_064)
internal val Res.string.delete_character_in_table_title: StringResource by lazy {
      StringResource("string:delete_character_in_table_title", "delete_character_in_table_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8088, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7444, 75),
      ))
    }

@delegate:ResourceContentHash(-1_125_447_199)
internal val Res.string.delete_premade: StringResource by lazy {
      StringResource("string:delete_premade", "delete_premade", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8467, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7811, 42),
      ))
    }

@delegate:ResourceContentHash(-282_441_339)
internal val Res.string.delete_premade_confirm: StringResource by lazy {
      StringResource("string:delete_premade_confirm", "delete_premade_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8229, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7569, 74),
      ))
    }

@delegate:ResourceContentHash(1_253_978_241)
internal val Res.string.delete_premade_message: StringResource by lazy {
      StringResource("string:delete_premade_message", "delete_premade_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8296, 170),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7644, 166),
      ))
    }

@delegate:ResourceContentHash(1_864_869_144)
internal val Res.string.delete_sound: StringResource by lazy {
      StringResource("string:delete_sound", "delete_sound", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8611, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7943, 36),
      ))
    }

@delegate:ResourceContentHash(-214_837_470)
internal val Res.string.delete_sound_confirm: StringResource by lazy {
      StringResource("string:delete_sound_confirm", "delete_sound_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8522, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7854, 88),
      ))
    }

@delegate:ResourceContentHash(-921_589_414)
internal val Res.string.delete_table: StringResource by lazy {
      StringResource("string:delete_table", "delete_table", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8923, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8239, 36),
      ))
    }

@delegate:ResourceContentHash(-586_062_363)
internal val Res.string.delete_table_confirm: StringResource by lazy {
      StringResource("string:delete_table_confirm", "delete_table_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8656, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7980, 44),
      ))
    }

@delegate:ResourceContentHash(556_689_833)
internal val Res.string.delete_table_dialog_message: StringResource by lazy {
      StringResource("string:delete_table_dialog_message", "delete_table_dialog_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8697, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8025, 159),
      ))
    }

@delegate:ResourceContentHash(-1_137_788_873)
internal val Res.string.delete_table_dialog_title: StringResource by lazy {
      StringResource("string:delete_table_dialog_title", "delete_table_dialog_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8861, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8185, 53),
      ))
    }

@delegate:ResourceContentHash(-34_103_787)
internal val Res.string.delete_universe: StringResource by lazy {
      StringResource("string:delete_universe", "delete_universe", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9120, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8400, 43),
      ))
    }

@delegate:ResourceContentHash(591_211_593)
internal val Res.string.delete_universe_confirm: StringResource by lazy {
      StringResource("string:delete_universe_confirm", "delete_universe_confirm", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8968, 151),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8276, 123),
      ))
    }

@delegate:ResourceContentHash(62_346_912)
internal val Res.string.description: StringResource by lazy {
      StringResource("string:description", "description", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9199, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8467, 35),
      ))
    }

@delegate:ResourceContentHash(-2_067_708_550)
internal val Res.string.dice: StringResource by lazy {
      StringResource("string:dice", "dice", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10592, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9756, 20),
      ))
    }

@delegate:ResourceContentHash(-409_635_138)
internal val Res.string.dice_color_label: StringResource by lazy {
      StringResource("string:dice_color_label", "dice_color_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9235, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8503, 40),
      ))
    }

@delegate:ResourceContentHash(-687_166_852)
internal val Res.string.dice_configure_label: StringResource by lazy {
      StringResource("string:dice_configure_label", "dice_configure_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9284, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8544, 40),
      ))
    }

@delegate:ResourceContentHash(-694_528_146)
internal val Res.string.dice_modifier_label: StringResource by lazy {
      StringResource("string:dice_modifier_label", "dice_modifier_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9329, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8585, 39),
      ))
    }

@delegate:ResourceContentHash(-2_098_405_134)
internal val Res.string.dice_one_face_bomb: StringResource by lazy {
      StringResource("string:dice_one_face_bomb", "dice_one_face_bomb", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9373, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8625, 34),
      ))
    }

@delegate:ResourceContentHash(-628_011_123)
internal val Res.string.dice_one_face_flame: StringResource by lazy {
      StringResource("string:dice_one_face_flame", "dice_one_face_flame", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9408, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8660, 35),
      ))
    }

@delegate:ResourceContentHash(1_178_818_563)
internal val Res.string.dice_one_face_label: StringResource by lazy {
      StringResource("string:dice_one_face_label", "dice_one_face_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9444, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8696, 43),
      ))
    }

@delegate:ResourceContentHash(-1_968_098_148)
internal val Res.string.dice_one_face_lightning: StringResource by lazy {
      StringResource("string:dice_one_face_lightning", "dice_one_face_lightning", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9488, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8740, 51),
      ))
    }

@delegate:ResourceContentHash(-1_020_786_845)
internal val Res.string.dice_one_face_none: StringResource by lazy {
      StringResource("string:dice_one_face_none", "dice_one_face_none", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9532, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8792, 50),
      ))
    }

@delegate:ResourceContentHash(630_155_641)
internal val Res.string.dice_one_face_poison: StringResource by lazy {
      StringResource("string:dice_one_face_poison", "dice_one_face_poison", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9595, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8843, 48),
      ))
    }

@delegate:ResourceContentHash(-412_919_322)
internal val Res.string.dice_one_face_skull: StringResource by lazy {
      StringResource("string:dice_one_face_skull", "dice_one_face_skull", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9644, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8892, 35),
      ))
    }

@delegate:ResourceContentHash(-1_990_013_217)
internal val Res.string.dice_one_face_swords: StringResource by lazy {
      StringResource("string:dice_one_face_swords", "dice_one_face_swords", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9692, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8928, 48),
      ))
    }

@delegate:ResourceContentHash(1_328_300_428)
internal val Res.string.dice_quantity_label: StringResource by lazy {
      StringResource("string:dice_quantity_label", "dice_quantity_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9745, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8977, 39),
      ))
    }

@delegate:ResourceContentHash(1_024_739_484)
internal val Res.string.dice_rolling_message_1: StringResource by lazy {
      StringResource("string:dice_rolling_message_1", "dice_rolling_message_1", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9785, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9017, 70),
      ))
    }

@delegate:ResourceContentHash(201_601_976)
internal val Res.string.dice_rolling_message_2: StringResource by lazy {
      StringResource("string:dice_rolling_message_2", "dice_rolling_message_2", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9864, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9088, 66),
      ))
    }

@delegate:ResourceContentHash(-1_433_003_693)
internal val Res.string.dice_rolling_message_3: StringResource by lazy {
      StringResource("string:dice_rolling_message_3", "dice_rolling_message_3", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9935, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9155, 66),
      ))
    }

@delegate:ResourceContentHash(1_382_798_402)
internal val Res.string.dice_rolling_message_4: StringResource by lazy {
      StringResource("string:dice_rolling_message_4", "dice_rolling_message_4", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10002, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9222, 70),
      ))
    }

@delegate:ResourceContentHash(-1_890_141_699)
internal val Res.string.dice_rolling_message_5: StringResource by lazy {
      StringResource("string:dice_rolling_message_5", "dice_rolling_message_5", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10077, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9293, 66),
      ))
    }

@delegate:ResourceContentHash(-1_369_413_833)
internal val Res.string.dice_rolling_message_6: StringResource by lazy {
      StringResource("string:dice_rolling_message_6", "dice_rolling_message_6", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10148, 82),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9360, 78),
      ))
    }

@delegate:ResourceContentHash(1_131_117_207)
internal val Res.string.dice_rolling_message_7: StringResource by lazy {
      StringResource("string:dice_rolling_message_7", "dice_rolling_message_7", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10231, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9439, 62),
      ))
    }

@delegate:ResourceContentHash(-1_408_669_184)
internal val Res.string.dice_rolling_message_8: StringResource by lazy {
      StringResource("string:dice_rolling_message_8", "dice_rolling_message_8", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10302, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9502, 86),
      ))
    }

@delegate:ResourceContentHash(1_291_992_825)
internal val Res.string.dice_rolling_message_9: StringResource by lazy {
      StringResource("string:dice_rolling_message_9", "dice_rolling_message_9", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10397, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9589, 70),
      ))
    }

@delegate:ResourceContentHash(815_898_245)
internal val Res.string.dice_tray_color_label: StringResource by lazy {
      StringResource("string:dice_tray_color_label", "dice_tray_color_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10476, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9660, 45),
      ))
    }

@delegate:ResourceContentHash(-273_284_201)
internal val Res.string.dice_tray_options: StringResource by lazy {
      StringResource("string:dice_tray_options", "dice_tray_options", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10530, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9706, 49),
      ))
    }

@delegate:ResourceContentHash(-609_002_947)
internal val Res.string.digicode_active_digicodes: StringResource by lazy {
      StringResource("string:digicode_active_digicodes", "digicode_active_digicodes", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10613, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9777, 53),
      ))
    }

@delegate:ResourceContentHash(457_581_789)
internal val Res.string.digicode_attempt_correct: StringResource by lazy {
      StringResource("string:digicode_attempt_correct", "digicode_attempt_correct", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10667, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9831, 48),
      ))
    }

@delegate:ResourceContentHash(1_845_911_642)
internal val Res.string.digicode_attempt_wrong: StringResource by lazy {
      StringResource("string:digicode_attempt_wrong", "digicode_attempt_wrong", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10716, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9880, 46),
      ))
    }

@delegate:ResourceContentHash(-1_568_412_222)
internal val Res.string.digicode_attempts_history: StringResource by lazy {
      StringResource("string:digicode_attempts_history", "digicode_attempts_history", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10767, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9927, 45),
      ))
    }

@delegate:ResourceContentHash(1_257_809_973)
internal val Res.string.digicode_attempts_label: StringResource by lazy {
      StringResource("string:digicode_attempts_label", "digicode_attempts_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10817, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 9973, 63),
      ))
    }

@delegate:ResourceContentHash(-1_385_904_283)
internal val Res.string.digicode_attempts_remaining: StringResource by lazy {
      StringResource("string:digicode_attempts_remaining", "digicode_attempts_remaining", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10881, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10037, 67),
      ))
    }

@delegate:ResourceContentHash(594_425_927)
internal val Res.string.digicode_backspace: StringResource by lazy {
      StringResource("string:digicode_backspace", "digicode_backspace", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 10949, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10105, 50),
      ))
    }

@delegate:ResourceContentHash(1_626_367_435)
internal val Res.string.digicode_cancel_activity: StringResource by lazy {
      StringResource("string:digicode_cancel_activity", "digicode_cancel_activity", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11012, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10156, 52),
      ))
    }

@delegate:ResourceContentHash(1_490_337_184)
internal val Res.string.digicode_close: StringResource by lazy {
      StringResource("string:digicode_close", "digicode_close", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11073, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10209, 30),
      ))
    }

@delegate:ResourceContentHash(-244_311_076)
internal val Res.string.digicode_digit_count_label: StringResource by lazy {
      StringResource("string:digicode_digit_count_label", "digicode_digit_count_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11104, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10240, 66),
      ))
    }

@delegate:ResourceContentHash(1_845_911_642)
internal val Res.string.digicode_failure_message: StringResource by lazy {
      StringResource("string:digicode_failure_message", "digicode_failure_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11175, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10307, 48),
      ))
    }

@delegate:ResourceContentHash(-174_957_236)
internal val Res.string.digicode_launch: StringResource by lazy {
      StringResource("string:digicode_launch", "digicode_launch", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11282, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10410, 31),
      ))
    }

@delegate:ResourceContentHash(-1_319_692_706)
internal val Res.string.digicode_launch_title: StringResource by lazy {
      StringResource("string:digicode_launch_title", "digicode_launch_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11228, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10356, 53),
      ))
    }

@delegate:ResourceContentHash(-1_853_812_831)
internal val Res.string.digicode_minimize: StringResource by lazy {
      StringResource("string:digicode_minimize", "digicode_minimize", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11314, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10442, 49),
      ))
    }

@delegate:ResourceContentHash(-1_878_580_739)
internal val Res.string.digicode_open: StringResource by lazy {
      StringResource("string:digicode_open", "digicode_open", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11368, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10492, 41),
      ))
    }

@delegate:ResourceContentHash(-750_355_109)
internal val Res.string.digicode_quit: StringResource by lazy {
      StringResource("string:digicode_quit", "digicode_quit", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11414, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10534, 29),
      ))
    }

@delegate:ResourceContentHash(902_098_725)
internal val Res.string.digicode_show_attempts: StringResource by lazy {
      StringResource("string:digicode_show_attempts", "digicode_show_attempts", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11448, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10564, 62),
      ))
    }

@delegate:ResourceContentHash(-1_678_222_087)
internal val Res.string.digicode_solution_label: StringResource by lazy {
      StringResource("string:digicode_solution_label", "digicode_solution_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11519, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10627, 67),
      ))
    }

@delegate:ResourceContentHash(-1_926_365_019)
internal val Res.string.digicode_sound_enabled: StringResource by lazy {
      StringResource("string:digicode_sound_enabled", "digicode_sound_enabled", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11591, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10695, 50),
      ))
    }

@delegate:ResourceContentHash(335_874_099)
internal val Res.string.digicode_success_message: StringResource by lazy {
      StringResource("string:digicode_success_message", "digicode_success_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11646, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10746, 52),
      ))
    }

@delegate:ResourceContentHash(-1_300_144_936)
internal val Res.string.digicode_target_player: StringResource by lazy {
      StringResource("string:digicode_target_player", "digicode_target_player", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11699, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10799, 50),
      ))
    }

@delegate:ResourceContentHash(1_316_952_564)
internal val Res.string.digicode_time_limit_enabled: StringResource by lazy {
      StringResource("string:digicode_time_limit_enabled", "digicode_time_limit_enabled", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11750, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10850, 59),
      ))
    }

@delegate:ResourceContentHash(1_802_156_497)
internal val Res.string.digicode_time_limit_label: StringResource by lazy {
      StringResource("string:digicode_time_limit_label", "digicode_time_limit_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11822, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10910, 57),
      ))
    }

@delegate:ResourceContentHash(513_208_820)
internal val Res.string.digicode_timeout_message: StringResource by lazy {
      StringResource("string:digicode_timeout_message", "digicode_timeout_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11884, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10968, 48),
      ))
    }

@delegate:ResourceContentHash(-505_126_138)
internal val Res.string.edit_avatar: StringResource by lazy {
      StringResource("string:edit_avatar", "edit_avatar", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11941, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11017, 35),
      ))
    }

@delegate:ResourceContentHash(-422_045_723)
internal val Res.string.edit_character: StringResource by lazy {
      StringResource("string:edit_character", "edit_character", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12045, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11105, 42),
      ))
    }

@delegate:ResourceContentHash(-1_192_835_029)
internal val Res.string.edit_character_name: StringResource by lazy {
      StringResource("string:edit_character_name", "edit_character_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 11985, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11053, 51),
      ))
    }

@delegate:ResourceContentHash(935_673_488)
internal val Res.string.edit_premade: StringResource by lazy {
      StringResource("string:edit_premade", "edit_premade", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12100, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11148, 40),
      ))
    }

@delegate:ResourceContentHash(-186_041_523)
internal val Res.string.edit_table_name: StringResource by lazy {
      StringResource("string:edit_table_name", "edit_table_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12153, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11189, 39),
      ))
    }

@delegate:ResourceContentHash(1_257_994_333)
internal val Res.string.edit_universe: StringResource by lazy {
      StringResource("string:edit_universe", "edit_universe", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12201, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11229, 41),
      ))
    }

@delegate:ResourceContentHash(1_012_814_592)
internal val Res.string.email: StringResource by lazy {
      StringResource("string:email", "email", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12247, 21),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11271, 21),
      ))
    }

@delegate:ResourceContentHash(1_620_260_899)
internal val Res.string.error_generic: StringResource by lazy {
      StringResource("string:error_generic", "error_generic", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12269, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11293, 45),
      ))
    }

@delegate:ResourceContentHash(472_929_791)
internal val Res.string.error_image_unreadable: StringResource by lazy {
      StringResource("string:error_image_unreadable", "error_image_unreadable", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12323, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11339, 118),
      ))
    }

@delegate:ResourceContentHash(1_391_646_545)
internal val Res.string.error_invalid_email: StringResource by lazy {
      StringResource("string:error_invalid_email", "error_invalid_email", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12458, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11458, 55),
      ))
    }

@delegate:ResourceContentHash(-229_303_277)
internal val Res.string.error_loading_characters: StringResource by lazy {
      StringResource("string:error_loading_characters", "error_loading_characters", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12518, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11514, 64),
      ))
    }

@delegate:ResourceContentHash(70_313_619)
internal val Res.string.error_loading_premades: StringResource by lazy {
      StringResource("string:error_loading_premades", "error_loading_premades", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12607, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11579, 74),
      ))
    }

@delegate:ResourceContentHash(-945_834_812)
internal val Res.string.error_loading_tables: StringResource by lazy {
      StringResource("string:error_loading_tables", "error_loading_tables", setOf(
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 12694, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 11654, 64),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("combat_order_hint", Res.string.combat_order_hint)
  map.put("combat_order_section", Res.string.combat_order_section)
  map.put("combat_players_section", Res.string.combat_players_section)
  map.put("combat_prepare_title", Res.string.combat_prepare_title)
  map.put("combat_remove_participant", Res.string.combat_remove_participant)
  map.put("combat_shuffle", Res.string.combat_shuffle)
  map.put("combat_stop", Res.string.combat_stop)
  map.put("configure_table", Res.string.configure_table)
  map.put("confirm", Res.string.confirm)
  map.put("confirm_premade_choice", Res.string.confirm_premade_choice)
  map.put("conversations", Res.string.conversations)
  map.put("copy_table_code", Res.string.copy_table_code)
  map.put("create", Res.string.create)
  map.put("create_character", Res.string.create_character)
  map.put("create_table", Res.string.create_table)
  map.put("create_universe", Res.string.create_universe)
  map.put("crossfading", Res.string.crossfading)
  map.put("custom_universe_snapshot_warning", Res.string.custom_universe_snapshot_warning)
  map.put("delete", Res.string.delete)
  map.put("delete_account", Res.string.delete_account)
  map.put("delete_account_confirm", Res.string.delete_account_confirm)
  map.put("delete_account_loading", Res.string.delete_account_loading)
  map.put("delete_account_message", Res.string.delete_account_message)
  map.put("delete_account_title", Res.string.delete_account_title)
  map.put("delete_character", Res.string.delete_character)
  map.put("delete_character_in_table_message", Res.string.delete_character_in_table_message)
  map.put("delete_character_in_table_title", Res.string.delete_character_in_table_title)
  map.put("delete_premade", Res.string.delete_premade)
  map.put("delete_premade_confirm", Res.string.delete_premade_confirm)
  map.put("delete_premade_message", Res.string.delete_premade_message)
  map.put("delete_sound", Res.string.delete_sound)
  map.put("delete_sound_confirm", Res.string.delete_sound_confirm)
  map.put("delete_table", Res.string.delete_table)
  map.put("delete_table_confirm", Res.string.delete_table_confirm)
  map.put("delete_table_dialog_message", Res.string.delete_table_dialog_message)
  map.put("delete_table_dialog_title", Res.string.delete_table_dialog_title)
  map.put("delete_universe", Res.string.delete_universe)
  map.put("delete_universe_confirm", Res.string.delete_universe_confirm)
  map.put("description", Res.string.description)
  map.put("dice", Res.string.dice)
  map.put("dice_color_label", Res.string.dice_color_label)
  map.put("dice_configure_label", Res.string.dice_configure_label)
  map.put("dice_modifier_label", Res.string.dice_modifier_label)
  map.put("dice_one_face_bomb", Res.string.dice_one_face_bomb)
  map.put("dice_one_face_flame", Res.string.dice_one_face_flame)
  map.put("dice_one_face_label", Res.string.dice_one_face_label)
  map.put("dice_one_face_lightning", Res.string.dice_one_face_lightning)
  map.put("dice_one_face_none", Res.string.dice_one_face_none)
  map.put("dice_one_face_poison", Res.string.dice_one_face_poison)
  map.put("dice_one_face_skull", Res.string.dice_one_face_skull)
  map.put("dice_one_face_swords", Res.string.dice_one_face_swords)
  map.put("dice_quantity_label", Res.string.dice_quantity_label)
  map.put("dice_rolling_message_1", Res.string.dice_rolling_message_1)
  map.put("dice_rolling_message_2", Res.string.dice_rolling_message_2)
  map.put("dice_rolling_message_3", Res.string.dice_rolling_message_3)
  map.put("dice_rolling_message_4", Res.string.dice_rolling_message_4)
  map.put("dice_rolling_message_5", Res.string.dice_rolling_message_5)
  map.put("dice_rolling_message_6", Res.string.dice_rolling_message_6)
  map.put("dice_rolling_message_7", Res.string.dice_rolling_message_7)
  map.put("dice_rolling_message_8", Res.string.dice_rolling_message_8)
  map.put("dice_rolling_message_9", Res.string.dice_rolling_message_9)
  map.put("dice_tray_color_label", Res.string.dice_tray_color_label)
  map.put("dice_tray_options", Res.string.dice_tray_options)
  map.put("digicode_active_digicodes", Res.string.digicode_active_digicodes)
  map.put("digicode_attempt_correct", Res.string.digicode_attempt_correct)
  map.put("digicode_attempt_wrong", Res.string.digicode_attempt_wrong)
  map.put("digicode_attempts_history", Res.string.digicode_attempts_history)
  map.put("digicode_attempts_label", Res.string.digicode_attempts_label)
  map.put("digicode_attempts_remaining", Res.string.digicode_attempts_remaining)
  map.put("digicode_backspace", Res.string.digicode_backspace)
  map.put("digicode_cancel_activity", Res.string.digicode_cancel_activity)
  map.put("digicode_close", Res.string.digicode_close)
  map.put("digicode_digit_count_label", Res.string.digicode_digit_count_label)
  map.put("digicode_failure_message", Res.string.digicode_failure_message)
  map.put("digicode_launch", Res.string.digicode_launch)
  map.put("digicode_launch_title", Res.string.digicode_launch_title)
  map.put("digicode_minimize", Res.string.digicode_minimize)
  map.put("digicode_open", Res.string.digicode_open)
  map.put("digicode_quit", Res.string.digicode_quit)
  map.put("digicode_show_attempts", Res.string.digicode_show_attempts)
  map.put("digicode_solution_label", Res.string.digicode_solution_label)
  map.put("digicode_sound_enabled", Res.string.digicode_sound_enabled)
  map.put("digicode_success_message", Res.string.digicode_success_message)
  map.put("digicode_target_player", Res.string.digicode_target_player)
  map.put("digicode_time_limit_enabled", Res.string.digicode_time_limit_enabled)
  map.put("digicode_time_limit_label", Res.string.digicode_time_limit_label)
  map.put("digicode_timeout_message", Res.string.digicode_timeout_message)
  map.put("edit_avatar", Res.string.edit_avatar)
  map.put("edit_character", Res.string.edit_character)
  map.put("edit_character_name", Res.string.edit_character_name)
  map.put("edit_premade", Res.string.edit_premade)
  map.put("edit_table_name", Res.string.edit_table_name)
  map.put("edit_universe", Res.string.edit_universe)
  map.put("email", Res.string.email)
  map.put("error_generic", Res.string.error_generic)
  map.put("error_image_unreadable", Res.string.error_image_unreadable)
  map.put("error_invalid_email", Res.string.error_invalid_email)
  map.put("error_loading_characters", Res.string.error_loading_characters)
  map.put("error_loading_premades", Res.string.error_loading_premades)
  map.put("error_loading_tables", Res.string.error_loading_tables)
}
